import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Building2, Users, HardHat, FileText } from "lucide-react";
import api from "@/lib/apiClient";

const GROUPS = [
  { key: "imprese", label: "Imprese", icon: Building2, path: "/imprese" },
  { key: "lavoratori", label: "Lavoratori", icon: Users, path: "/lavoratori" },
  { key: "cantieri", label: "Cantieri", icon: HardHat, path: "/cantieri" },
  { key: "documenti", label: "Documenti", icon: FileText, path: "/documenti" },
];

export function GlobalSearch() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (q.trim().length < 2) { setRes(null); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/search`, { params: { q } });
        setRes(data); setOpen(true);
      } catch (_) {}
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const go = (path, id) => {
    setOpen(false); setQ("");
    navigate(`${path}/${id}`);
  };

  const total = res ? GROUPS.reduce((a, g) => a + (res[g.key]?.length || 0), 0) : 0;

  return (
    <div className="relative w-full max-w-md" ref={boxRef}>
      <div className="flex items-center gap-2 rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 h-10">
        <Search className="h-4 w-4 text-muted-foreground" />
        <input
          data-testid="global-search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onFocus={() => res && setOpen(true)}
          placeholder="Cerca imprese, lavoratori, CF, P.IVA, CIG…"
          className="flex-1 bg-transparent text-sm outline-none"
        />
      </div>
      {open && res && (
        <div className="absolute z-50 mt-2 w-full rounded-lg border bg-white dark:bg-slate-900 shadow-xl max-h-[70vh] overflow-y-auto" data-testid="search-results">
          {total === 0 && <div className="p-4 text-sm text-muted-foreground">Nessun risultato per "{q}"</div>}
          {GROUPS.map((g) => (res[g.key]?.length > 0 && (
            <div key={g.key} className="p-2">
              <div className="px-2 py-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground flex items-center gap-1.5">
                <g.icon className="h-3.5 w-3.5" /> {g.label}
              </div>
              {res[g.key].map((r) => (
                <button key={r.id} onClick={() => go(g.path, r.id)}
                  className="w-full text-left px-3 py-2 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 flex items-center justify-between">
                  <span className="text-sm font-medium">{r.nome}</span>
                  {r.sub && <span className="text-xs text-muted-foreground font-mono">{r.sub}</span>}
                </button>
              ))}
            </div>
          )))}
        </div>
      )}
    </div>
  );
}
